/* eslint-disable camelcase */
import {
    UPDATE_SURGERY_DETAILS_SUCCESS,
    UPDATE_SURGERY_DETAILS_FAILURE,
    SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
} from '../actions';

import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { removeEmptyFieldsFromObject } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* updateSurgery(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/order/surgery`;
    const isSubmitted = action.payload.isSubmittedFromSurgeryFlow;
    delete action.payload.isSubmittedFromSurgeryFlow;
    const payload = removeEmptyFieldsFromObject(action.payload);

    try {
        const result = yield axios
            .put(url, payload)
            .then((response) => response.data);
        if (result.myCaseRef) {
            const modify_result = {
                ...result,
                isSubmitted,
            };
            yield put({
                type: UPDATE_SURGERY_DETAILS_SUCCESS,
                data: modify_result,
            });
            yield put({
                type: SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
                data: false,
            });
        } else {
            yield put({
                type: UPDATE_SURGERY_DETAILS_FAILURE,
                data: {
                    message: errorHandler('999'),
                    statusCode: '999',
                },
            });
        }
    } catch (error) {
        yield logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: payload || '',
        });
        yield put({
            type: UPDATE_SURGERY_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
